import React, { useState } from "react";

const portfolioImages = [
  // Новый год (главное фото на обзоре)
  {
    id: 1,
    url: "https://static.lumi.new/cb/cbf9dc462338d1045e75ea73265ddff6.jpg",
    title: "Новогодний корпоратив",
    category: "Новый год",
    featured: true
  },
  {
    id: 2,
    url: "https://cdn-static-lumi.artvibe.ai/2f/2f095b17f64e0847b1dab82c6b1a477a.jpg",
    title: "Новогоднее празднование",
    category: "Новый год",
    featured: false
  },
  {
    id: 3,
    url: "https://cdn-static-lumi.artvibe.ai/b9/b9171d14742e89eccdc700bec1313309.jpg",
    title: "Новогодняя вечеринка",
    category: "Новый год",
    featured: false
  },
  {
    id: 17,
    url: "https://static.lumi.new/c0/c0783bb2656913fe46d4f626d793e559.png",
    title: "Новогоднее торжество",
    category: "Новый год",
    featured: true
  },
  {
    id: 18,
    url: "https://cdn-static-lumi.artvibe.ai/3e/3e8aa899f1684e66afffb95a940a6c31.jpg",
    title: "Новогодний праздник",
    category: "Новый год",
    featured: false
  },
  // Свадьба (главное фото на обзоре)
  {
    id: 4,
    url: "https://cdn-static-lumi.artvibe.ai/00/001ea3b8999b56c760d8d1b5074ad8cb.jpg",
    title: "Элегантная свадебная церемония",
    category: "Свадьба",
    featured: true
  },
  {
    id: 5,
    url: "https://cdn-static-lumi.artvibe.ai/63/63fd2c4b9bfe0a2930be5fa91cc08c43.jpg",
    title: "Свадебная вечеринка",
    category: "Свадьба",
    featured: false
  },
  {
    id: 6,
    url: "https://cdn-static-lumi.artvibe.ai/79/79b708c9f2668d1c26799e14d758821e.png",
    title: "Свадебное торжество",
    category: "Свадьба",
    featured: false
  },
  {
    id: 10,
    url: "https://cdn-static-lumi.artvibe.ai/b2/b214d0d26c2570582ed221fd58d7d33d.png",
    title: "Свадебная церемония",
    category: "Свадьба",
    featured: false
  },
  {
    id: 11,
    url: "https://cdn-static-lumi.artvibe.ai/b8/b89a8b177db431b7f7fd345ac1f629a5.png",
    title: "Свадебное празднование",
    category: "Свадьба",
    featured: false
  },
  {
    id: 12,
    url: "https://cdn-static-lumi.artvibe.ai/97/971624e07f1238c0bbc61e2052495040.jpg",
    title: "Свадебный банкет",
    category: "Свадьба",
    featured: false
  },
  // Мафия (главное фото на обзоре)
  {
    id: 7,
    url: "https://cdn-static-lumi.artvibe.ai/44/440d5c2d9ff44a8a5ca6be661411d557.jpg",
    title: "Мафия-вечеринка",
    category: "Мафия",
    featured: true
  },
  {
    id: 8,
    url: "https://cdn-static-lumi.artvibe.ai/d3/d3d9503ece9085cf6c75b5e02a794aeb.jpg",
    title: "Игра в мафию",
    category: "Мафия",
    featured: false
  },
  {
    id: 9,
    url: "https://cdn-static-lumi.artvibe.ai/e9/e946ff496b7a5997b0ce97c2bd277f87.jpg",
    title: "Тематическая мафия-вечеринка",
    category: "Мафия",
    featured: false
  },
  // Гендер-пати (главное фото на обзоре)
  {
    id: 19,
    url: "https://static.lumi.new/ee/ee1f0f2114a40fbae5f7ba8c4a85d496.jpg",
    title: "Гендер-пати мероприятие",
    category: "Гендер-пати",
    featured: false
  },
  {
    id: 20,
    url: "https://static.lumi.new/33/33af654b4715ff499a5c378e9ff721e9.png",
    title: "Гендер-пати праздник",
    category: "Гендер-пати",
    featured: false
  },
  // Спортивные мероприятия (главное фото на обзоре)
  {
    id: 13,
    url: "https://cdn-static-lumi.artvibe.ai/b0/b041ddfb168ce691ec2a7a6d1d0f1b4d.png",
    title: "Спортивное мероприятие",
    category: "Все",
    featured: true
  },
  {
    id: 14,
    url: "https://static.lumi.new/9f/9f6fd862bd6f36bbab4af617dae09a63.png",
    title: "Спортивное событие",
    category: "Спортивные мероприятия",
    featured: true
  },
  {
    id: 24,
    url: "https://static.lumi.new/21/2174ac16cb01b71b5b2e928613324216.png",
    title: "Спортивный праздник",
    category: "Спортивные мероприятия",
    featured: false
  },
  // Детский праздник (главное фото на обзоре)
  {
    id: 15,
    url: "https://cdn-static-lumi.artvibe.ai/f3/f356f4c15e16cd7d37b367831a0f828b.jpg",
    title: "Детский праздник",
    category: "Детский праздник",
    featured: true
  },
  {
    id: 16,
    url: "https://cdn-static-lumi.artvibe.ai/76/76761e3d436f84b960bd867b81881660.png",
    title: "День рождения ребёнка",
    category: "Детский праздник",
    featured: false
  },
  {
    id: 21,
    url: "https://static.lumi.new/ad/ad24632215c8a16c65cbc4e6313eff1f.png",
    title: "Детское мероприятие",
    category: "Детский праздник",
    featured: false
  },
  // Общие фото (для раздела "Все")
  {
    id: 22,
    url: "https://static.lumi.new/8d/8dfbd3ccbc02f9551717187fdad2eb5f.png",
    title: "Яркое мероприятие",
    category: "Все",
    featured: true
  },
  {
    id: 23,
    url: "https://static.lumi.new/47/47bdd31128094471076610bcc25e0977.png",
    title: "Праздничное событие",
    category: "Все",
    featured: true
  }
];


function Portfolio() {
  const [filter, setFilter] = useState("Все");
  const categories = ["Все", "Новый год", "Свадьба", "Мафия", "Гендер-пати", "Спортивные мероприятия", "Детский праздник"];

  const filteredImages = filter === "Все" ?
  portfolioImages.filter((img) => img.featured) :
  portfolioImages.filter((img) => img.category === filter);

  return (
    <section id="portfolio" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">Обзор проведённых мероприятий</h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">Коллекция ярких моментов, созданных мной с душой и профессионализмом. Каждое мероприятие индивидуально, и я отношусь к каждому событию ответственно и увлечённо.


          </p>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) =>
          <button
            key={category}
            onClick={() => setFilter(category)}
            className={`px-6 py-2 rounded-full font-medium transition ${
            filter === category ?
            "bg-pink-300 text-black shadow-lg shadow-pink-300/30" :
            "bg-gray-900 text-gray-300 border border-pink-300/30 hover:bg-pink-300/10"}`
            }>

              {category}
            </button>
          )}
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredImages.map((image) =>
          <div
            key={image.id}
            className="group relative overflow-hidden rounded-2xl shadow-lg shadow-pink-300/10 hover:shadow-2xl hover:shadow-pink-300/20 transition-all duration-300 transform hover:-translate-y-2 border border-pink-300/20">

              <img
              src={image.url}
              alt={image.title}
              className="w-full h-72 object-cover transition-transform duration-300 group-hover:scale-110" />

              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="inline-block bg-pink-300 text-black text-xs px-3 py-1 rounded-full mb-2">
                    {image.category}
                  </div>
                  <h3 className="text-white text-xl font-bold">{image.title}</h3>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Show more button */}
        <div className="text-center mt-12">
          <button 
            onClick={() => setFilter("Все")}
            className="bg-pink-300 text-black px-8 py-3 rounded-lg font-semibold hover:bg-pink-400 transition shadow-lg shadow-pink-300/20">
            Смотреть всё портфолио
          </button>
        </div>
      </div>
    </section>);

}

export default Portfolio;